import { Box, Button } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { brandPalette } from "../../../constants/brandPalette";

const SuperAdminAssistantsTable = ({ onShowPassword, searchTerm = "" }) => {
  const assistants = useSelector((state) => state.teacherassistants.teacherassistants);
  const isLoading = useSelector((state) => state.teacherassistants.isLoading);
  const [, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const list = useMemo(() => {
    const raw = Array.isArray(assistants) ? assistants : [];
    const q = searchTerm.trim().toLowerCase();
    if (!q) return raw;
    return raw.filter(
      (assistant) =>
        String(assistant?.name ?? "").toLowerCase().includes(q) ||
        String(assistant?.phone ?? "").toLowerCase().includes(q)
    );
  }, [assistants, searchTerm]);

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  const Data = list.map((data) => ({
    id: data?.id,
    name: data?.name,
    phone: data?.phone,
    subject: data?.subject?.name,
    group: data?.group?.name,
    showPassword: (
      <Button
        size="sm"
        variant="outline"
        borderRadius="full"
        borderColor={brandPalette.stone}
        color={brandPalette.primary}
        fontWeight="700"
        _hover={{ bg: "rgba(91, 13, 22, 0.08)" }}
        onClick={(e) => {
          e.stopPropagation();
          onShowPassword(data);
        }}
      >
        Show password
      </Button>
    ),
  }));

  const columns = [
    { Header: "Name", accessor: "name" },
    { Header: "Phone", accessor: "phone" },
    { Header: "Subject", accessor: "subject" },
    { Header: "Group", accessor: "group" },
    { Header: "Password", accessor: "showPassword" },
  ];

  const totalPage = Math.max(1, Math.ceil(list.length / size));

  return (
    <Box px={{ base: 4, md: 8 }} pb={10} w="100%">
      <Box
        bg="var(--surface-raised)"
        border="1px solid"
        borderColor={brandPalette.stone}
        borderRadius="16px"
        overflow="hidden"
        boxShadow="sm"
      >
        <CTable
          selectedData={() => {}}
          Columns={columns}
          Data={Data}
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          isLoading={isLoading}
          perPage={size}
          totalPage={totalPage}
          wrapperProps={{ maxH: "unset", overflow: "auto" }}
          tableProps={{ bg: "transparent", borderRadius: "0", mb: 0 }}
          theadProps={{ bg: "var(--surface-muted)", color: "var(--text-primary)" }}
        />
      </Box>
    </Box>
  );
};

export default SuperAdminAssistantsTable;
